import {
  awaitAnimate,
  Particle,
  ParticleModes,
} from "../../../engine/anims/Particle";
import Colors from "../../Colors";

export const SelectedWordParticle = {
  mode: ParticleModes.DRAW_OVER_LAST,
  char: null,
  fg: Colors.ORANGE_3,
  bg: null,
  animate: async (particle: Particle<string>) => {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      await awaitAnimate({
        driver: particle.driver,
        from: particle.options,
        to: Colors.YELLOW_2,
        duration: 400,
        onUpdate: (latest) => {
          particle.fg = latest;
        },
      });

      await awaitAnimate({
        driver: particle.driver,
        from: Colors.YELLOW_2,
        to: particle.options || Colors.RED,
        duration: 600,
        onUpdate: (latest) => {
          particle.fg = latest;
        },
      });

      await new Promise((r) => setTimeout(r, 100));
    }
  },
};
